import { FC } from "react";

export const NotFoundPage: FC = () => {
  return (
    <div className="flex justify-center items-center h-screen bg-transparent">
      <h3 className="text-yellow text-4xl font-usual-bold tracking-widest">
        Not Found!
      </h3>
    </div>
  );
};
